// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dc89a40a","389":"31c28ff6","453":"a3ae4db9","455":"2217b1d9","857":"59b998e6","977":"a6f700dc"}[chunkId] + ".chunk.js";
};